import { useMemo } from 'react'
import { fonts } from 'types'
import { SelectList } from 'ui'
import { fontFamily, fontScale, fontTitle } from 'utils'
import { FontButton } from './style'

const FONTS = fonts.map((font) => (
    <span key={fontTitle(font)} style={{ fontFamily: fontFamily(font), fontSize: `${fontScale(font)}em` }}>
        {fontTitle(font)}
    </span>
))

type Props = {
    fontFamily: string
    onChange?: (family: string, scale: number) => void
}

const CaptionEditorStyleOptionsFont = ({ fontFamily: fontFamilyProp, onChange }: Props) => {
    const defaultFontIndex = useMemo(() => {
        const index = fonts.findIndex((font) => {
            if (fontFamily(font) === fontFamilyProp) {
                return true
            }
            return false
        })

        return index
    }, [fontFamilyProp])

    const onFontChange = (index: number) => {
        const font = fonts[index]
        const family = fontFamily(font)
        const scale = fontScale(font)

        onChange?.(family, scale)
    }

    return (
        <FontButton
            label={
                <span
                    style={{
                        fontFamily: fontFamilyProp,
                        fontSize: `${defaultFontIndex < 0 ? 1 : fontScale(fonts[defaultFontIndex])}em`,
                        marginRight: 'auto',
                    }}
                >
                    {defaultFontIndex < 0 ? fontFamilyProp : fontTitle(fonts[defaultFontIndex])}
                </span>
            }
        >
            <SelectList defaultIndex={defaultFontIndex} options={FONTS} onChange={onFontChange} />
        </FontButton>
    )
}

export default CaptionEditorStyleOptionsFont
